var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-emoji"},[_vm._l((_vm.emojis),function(emoji,i){return [_c('img',{key:i,attrs:{"src":emoji.url,"alt":emoji.name,"data-key":emoji.key},on:{"click":function($event){return _vm.select(emoji.key)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }